module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-FrameB",
    attrs: {
      "id": "_idContainer005b"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    staticStyle: {
      "border-bottom": "solid black 2px",
      "margin-right": "10%",
      "margin-left": "10%"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2b"
  }, [_c('a', {
    attrs: {
      "id": "other"
    }
  }), _vm._v("Other "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peanuts")]), _vm._v(" AMP! \nComics for Kids Books")])]), _vm._v(" "), _c('p', {
    staticClass: "italic"
  }, [_vm._v("Snoopy: Cowabunga")]), _vm._v(" "), _c('p', {
    staticClass: "italic"
  }, [_vm._v("Charlie Brown and Friends")]), _vm._v(" "), _c('p', {
    staticClass: "italic"
  }, [_vm._v("Charlie Brown: Pow!")]), _vm._v(" "), _c('p', {
    staticClass: "italic"
  }, [_vm._v("Woodstock: Master of Disguise")]), _vm._v(" "), _c('p', {
    staticClass: "italic"
  }, [_vm._v("Snoopy: Contact!")]), _vm._v(" "), _c('p', {
    staticClass: "italic"
  }, [_vm._v("Snoopy: Party Animal")]), _vm._v(" "), _c('p', {
    staticClass: "italic"
  }, [_vm._v("Charlie Brown: Here We Go Again")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "snoopy"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "image/img005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img014.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img015.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img017.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img018.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img019.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img020.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img021.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img022.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img023.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img024.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img025.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img026.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img027.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img028.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img029.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img030.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img031.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img032.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img033.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img034.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img035.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img036.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img037.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img038.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img039.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img040.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img041.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img042.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img043.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img044.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img045.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img046.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img047.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img048.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img049.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img050.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img051.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img052.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img053.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img054.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img055.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img056.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img057.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img058.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img059.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img060.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img061.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img062.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img063.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img064.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img065.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img066.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img067.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img068.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img069.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img070.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img071.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img072.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img073.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img074.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img075.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img076.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img077.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img078.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/img079.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa3b9f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch1.vue
// module id = 57
// module chunks = 0